import React, { useState, useEffect } from 'react';
import styles from '../../../styles/ListingManagement.module.css';
import type { ListingImage } from '../../../types/ListingTypes';


interface DetailProps {
    images: any;
}

const ListingImages: React.FC<DetailProps> = ({ images }) => {
    const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);

    useEffect(() => {
        if (lightboxIndex === null) return;
        const handleKey = (e: KeyboardEvent) => {
        if (e.key === 'Escape') setLightboxIndex(null);
        if (e.key === 'ArrowRight') setLightboxIndex(i => i !== null ? (i + 1) % images.length : null);
        if (e.key === 'ArrowLeft') setLightboxIndex(i => i !== null ? (i - 1 + images.length) % images.length : null);
        };
        window.addEventListener('keydown', handleKey);
        return () => window.removeEventListener('keydown', handleKey);
    }, [lightboxIndex, images]);

    return (
        <div>
            {images.length > 0 && (
                <section className={styles.agreementFormSection}>
                    <h4>Images</h4>
                    <div className={styles.imageGrid}>
                        {images.map((img: ListingImage, idx: number) => (
                            <div
                                key={img.id}
                                className={`${styles.imageGridItem} ${styles.imageGridItemClickable}`}
                                onClick={() => img.url && setLightboxIndex(idx)}
                                role="button"
                                tabIndex={0}
                                onKeyDown={e => e.key === 'Enter' && img.url && setLightboxIndex(idx)}
                                aria-label={`View ${img.type} image`}
                            >
                                {img.url ? (
                                    <img src={img.url} alt={img.type} />
                                ) : (
                                    <div style={{ height: 160, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#adb5bd', fontSize: '0.85em' }}>
                                        No preview
                                    </div>
                                )}
                                <span className={styles.imageGridItemLabel}>{img.type}</span>
                            </div>
                        ))}
                    </div>
                </section>
            )}
            {/* Lightbox */}
            {lightboxIndex !== null && images[lightboxIndex]?.url && (
                <div className={styles.lightboxOverlay} onClick={() => setLightboxIndex(null)}>
                    <button className={styles.lightboxClose} onClick={() => setLightboxIndex(null)} aria-label="Close">&times;</button>
                    {images.length > 1 && (
                        <button
                            className={`${styles.lightboxNav} ${styles.lightboxNavPrev}`}
                            onClick={e => { e.stopPropagation(); setLightboxIndex(i => i !== null ? (i - 1 + images.length) % images.length : null); }}
                            aria-label="Previous"
                        >&#8249;</button>
                    )}
                    <div className={styles.lightboxContent} onClick={e => e.stopPropagation()}>
                        <img src={images[lightboxIndex].url!} alt={images[lightboxIndex].type} className={styles.lightboxImage} />
                        <div className={styles.lightboxCaption}>
                            {images[lightboxIndex].type}
                            {images.length > 1 && (
                                <span className={styles.lightboxCounter}> {lightboxIndex + 1} / {images.length}</span>
                            )}
                        </div>
                    </div>
                    {images.length > 1 && (
                        <button
                            className={`${styles.lightboxNav} ${styles.lightboxNavNext}`}
                            onClick={e => { e.stopPropagation(); setLightboxIndex(i => i !== null ? (i + 1) % images.length : null); }}
                            aria-label="Next"
                        >&#8250;</button>
                    )}
                </div>
            )}
        </div>
    );
}

export default ListingImages;